import { render, staticRenderFns } from "./CentroCustoForm.vue?vue&type=template&id=23f1c8af"
import script from "./CentroCustoForm.vue?vue&type=script&lang=js"
export * from "./CentroCustoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports